import React from 'react';
import { StarIcon, MapPinIcon } from 'lucide-react';
export type Testimonial = {
  quote: string;
  author: string;
  role: string;
  location: string;
  photo: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  background?: 'ivory' | 'white';
};
export function Testimonials({
  testimonials,
  title,
  background = 'white'
}: TestimonialsProps) {
  return <section className={`w-full ${background === 'white' ? 'bg-white' : 'bg-ivory'} py-16 sm:py-20`} data-id="element-302" data-mp="36zin5dek8go9">
      <div className="mx-auto max-w-6xl px-5" data-id="element-303" data-mp="31zmrc1g0nvjs">
        {title && <>
            <h2 className="text-center font-serif text-3xl sm:text-4xl text-ink" data-id="element-304" data-mp="2x09uqozcfa40">
              {title}
            </h2>
            <div className="rule-gold mx-auto mt-6 w-32" aria-hidden="true" data-id="element-305" data-mp="2s2rvjqb4o997" />
          </>}

        <ul className={`grid gap-6 sm:grid-cols-3 ${title ? 'mt-12' : ''}`} data-id="element-306" data-mp="v8dmppcdwidz">
          {testimonials.map(testimonial => <li key={testimonial.quote} className={`flex flex-col border border-gold-soft/70 p-7 ${background === 'white' ? 'bg-ivory' : 'bg-white'}`} data-id="element-307" data-mp="qb509ck7ds6x">
              <div className="flex gap-1" aria-label="5 out of 5 stars" data-id="element-308" data-mp="77s6rx2wc6yr">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-309" data-mp="c7wofqfjj7qk" data-mpi={index} />)}
              </div>
              <blockquote className="mt-5 flex-1 font-serif text-lg leading-relaxed text-ink" data-id="element-310" data-mp="14uzlee4kjaep">
                &ldquo;{testimonial.quote}&rdquo;
              </blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-gold-soft/70 pt-5" data-id="element-311" data-mp="v4xulektzdw3">
                <img src={testimonial.photo} alt={`Portrait of ${testimonial.author}`} className="h-12 w-12 shrink-0 rounded-full border border-gold-soft object-cover" loading="lazy" data-id="element-312" data-mp="1iv1y7ly0rdn3" />
                <span data-id="element-313" data-mp="1siwdqiikhw7s">
                  <span className="block text-sm font-semibold text-ink" data-id="element-314" data-mp="1sio20ty6kwy6">
                    {testimonial.author}
                  </span>
                  <span className="block text-[11px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-315" data-mp="1ofhnkz0wzzgm">
                    {testimonial.role}
                  </span>
                  <span className="mt-1 inline-flex items-center gap-1.5 text-[11px] text-gold-dark" data-id="element-316" data-mp="1ejel1s25hyt5">
                    <MapPinIcon className="h-3 w-3" aria-hidden="true" data-id="element-317" data-mp="19s6f56014vkq" />
                    {testimonial.location}
                  </span>
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}